import { useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { useEffect } from "react";
import { Toast } from "primereact/toast";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase/Firebase";

function CreateModal(props) {
  const [title, setTitle] = useState("");
  const [start, setStart] = useState();
  const [end, setEnd] = useState();
  const [desc, setDesc] = useState("");
  const [color, setColor] = useState("");

  const setCounter = props.setCounter; // to refresh the use state in tasks.jsx
  const counter = props.counter;
  useEffect(() => {
    setStart(props.start);
    setEnd(props.end);
  }, [props]);

  const shows = props.showModal;
  const setShow = props.setShowModal;

  const handleClose = (event) => {
    setShow(false);
  };

  const toast = useRef(null);
  const [loading, setLoading] = useState(false);

  const createEvent = async (e) => {
    e.preventDefault();
    setLoading(true);
    var userValue = JSON.parse(localStorage.getItem("user"));

    if (!title || !start || !end) {
      toast.current.show({
        severity: "error",
        summary: "error",
        detail: "Check Requred Fields",
      });
      setLoading(false);
      return; // Exit early if required fields are missing
    }

    try {
      const createdAt = new Date(); // Generate current date and time
      const docRef = await addDoc(collection(db, "events"), {
        userID: userValue.uid,
        title: title.trim(),
        start: start,
        end: end,
        desc: desc.trim(),
        color: color,
        created_at: createdAt,
      });
      // console.log("Document written with ID: ", docRef.id);

      toast.current.show({
        severity: "info",
        summary: "Info",
        detail: "Event has been successfully set.",
      });

      handleClose();
      setTitle("");
      setDesc("");
      setColor("#4c55d6");
      setCounter(counter + 1);
    } catch (error) {
      toast.current.show({
        severity: "error", // Changed severity to error
        summary: "Error",
        detail: error.message,
      });
    } finally {
      setLoading(false); // Ensure setLoading(false) is called in all scenarios
    }
  };

  return (
    <>
      {" "}
      <Toast ref={toast} />
      <Modal
        show={shows}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Event</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={createEvent}>
            <Form.Group controlId="formTitle">
              <Form.Label className="text-success ">
                Title <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter title"
                onChange={(e) => setTitle(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formStart" className="p-1">
              <Form.Label className="text-success ">
                Start<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="datetime-local"
                defaultValue={props.start}
                onChange={(e) => setStart(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formEnds" className="p-1">
              <Form.Label className="text-success ">
                Ends<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="datetime-local"
                defaultValue={props.end}
                onChange={(e) => setEnd(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formDesc" className="p-1">
              <Form.Label className="text-success ">Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                onChange={(e) => setDesc(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formColor" className="p-1">
              <Form.Label className="text-success ">Color</Form.Label>
              <Form.Control
                defaultValue="#0362fc"
                type="color"
                onChange={(e) => setColor(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {!loading && (
            <Button variant="primary" onClick={createEvent}>
              Save
            </Button>
          )}
          {loading && (
            <Button variant="primary" disabled>
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              Saving...
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CreateModal;
